import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { TextField } from "../../../components";

export default function ActionPopUp({
  handleApprovalStatus,
  actionPopup,
  setActionPopup,
  loading,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={actionPopup.state}
      onClose={() => setActionPopup({ state: false })}
    >
      <DialogTitle style={{ fontWeight: 700, fontSize: "17px" }}>
        Take Actions
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ marginBottom: "15px" }} fontSize={"15px"}>
          Are you sure you want to {actionPopup.status} campaign?
        </Typography>

        {actionPopup.status === "Reject" && (
          <Grid container spacing={2}>
            <Grid size={12}>
              <TextField
                label={"Reject Reason"}
                onChange={(e) => e.target.value}
                multiline
                rows={3}
                name={"rejectReason"}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions>
        <CancelButton
          variant="outlined"
          onClick={() => setActionPopup({ state: false })}
        >
          Cancel
        </CancelButton>

        <PrimaryLoadingButton
          loading={loading[actionPopup.data?.requestStatus]}
          onClick={handleApprovalStatus}
          variant="contained"
        >
          {actionPopup.status}
        </PrimaryLoadingButton>
      </DialogActions>
    </Dialog>
  );
}
